import React from 'react'
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Paid from '../../Assets/images/paid.png'
import Button from '../SelectValue/Button';
import { Link, useNavigate } from 'react-router-dom';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  height: 500,
  bgcolor: 'white',
  boxShadow: 24,
};

function RequestModal({ open, handleClose, apartmentId }) {
  const navigate = useNavigate();
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style} className='rounded-lg flex justify-center items-center px-6'>
            <div className='flex flex-col gap-10 items-center w-full'>
              <div className='flex flex-col justify-center items-center text-center  leading-[150%]  gap-3'>
                <img src={Paid} alt='Send' className='' />
                <p className=' font-[500] text-[20px] text-[#1E222B]'>Request sent to join #{apartmentId}</p>
                <p className=' font-[500] text-[16px] text-[#808285]'>You will get an invite to select your apartment shortly. Thank you</p>
              </div>
              <Button
                className="w-full"
                name='See pending rent'
                onClick={() => {
                  navigate("pending");
                  window.dispatchEvent(new Event("rent-updated"));
                  handleClose();
                }}
              />
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  )
}

export default RequestModal